export default "__VITE_ASSET__JAJZ5LlP__"